<template>
  <b-modal id="client-card-modal" ok-only ok-title="Закрыть">
    <template slot="modal-title">
      <div class="d-flex align-items-center">
        <icon class="mr-3" name="user"/>
        <span>Информация о клиенте</span>
      </div>
    </template>
    <template v-if="client">
      <div class="d-flex justify-content-between"><b>Бренд:</b><span>{{client.brand.name}}</span></div>
      <hr>
      <div class="d-flex justify-content-between"><b>Имя клиента:</b><span>{{client.name}}</span></div>
      <hr>
      <div class="d-flex justify-content-between"><b>Номер телефона:</b><span>{{client.phone}}</span></div>
      <hr>
      <div class="d-flex justify-content-between"><b>Скидка клиента:</b><span>{{client.discount}}</span></div>
      <hr>
      <div class="d-flex justify-content-between"><b class="mt-1">Комментарий:</b><b-input class="ml-4" v-model.trim="clientComment"></b-input></div>
      <div class="d-flex justify-content-between mt-2">
        <b-button class="w-100 mr-1" :disabled="!commentWasChanged" @click="resetComment()" variant="danger" size="sm">Отменить</b-button>
        <b-button class="w-100 ml-1" :disabled="!commentWasChanged" @click="updateComment" variant="success" size="sm">Сохранить</b-button>
      </div>
      <hr>
      <template v-if="client.lastAddresses">
        <h5>Последние адреса:</h5>
        <div>
          <div v-if="client.lastAddresses.nodes.length === 0">
            Адресов для доставки не найдено
          </div>
          <div class="address" @click="setOrderAddress(address)"  v-for="(address, ind) in client.lastAddresses.nodes" :key="ind">
            {{formatAddress(address)}}
          </div>
        </div>
      </template>
    </template>
  </b-modal>
</template>

<script>
import clientQueries from '../../graphql/clientQueries'
import {orderMUT} from '../../constants/vuexMutations'
import {callCenterGetters} from '../../constants/vuexGetters'
import {callCenterACT} from '../../constants/vuexActions'
import addressFunc from '../../helpers/formatAddress'
export default {
  name: 'ClientCard',
  props: {
  },
  data () {
    return {
      vuexNamespace: 'callCenter',
      clientComment: '',
      initClientComment: ''
    }
  },
  computed: {
    client () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.CLIENT_CURRENT_ORDER}`]
    },
    commentWasChanged () {
      return this.initClientComment !== this.clientComment
    }
  },
  watch: {
    client (newValue) {
      if (newValue) {
        this.clientComment = newValue.comment
        this.initClientComment = this.clientComment
      }
    }
  },
  methods: {
    formatAddress: addressFunc.fullNameAddress,
    setOrderAddress (address) {
      this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.UPDATE_ORDER_ADDRESS}`, address)
    },
    resetComment () {
      this.clientComment = this.initClientComment
    },
    updateComment () {
      this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.UPDATE_CLIENT_COMMENT}`, this.clientComment).then(res => {
        this.initClientComment = this.clientComment
      })
    },
    showModalClientCard () {
      this.$bvModal.show('client-card-modal')
    }
  }
}
</script>

<style scoped>
  .address {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ClientCard.vue